import { formPdf, finishPdf } from './formPdf';
import { formDef } from './clinicalForms';

const picked = (v) => (Array.isArray(v) ? v : v ? [v] : []);
const usDate = (v) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v || '')); return m ? `${m[2]}/${m[3]}/${m[1]}` : String(v || ''); };
const NA = /^\s*not (available|provided|specified|documented|stated|mentioned|found|recorded)\b/i;
const val = (x) => (x == null || NA.test(String(x)) ? '' : x);

// Editable PDF of a clinical form; every box/tick stays fillable
export const buildClinicalFormPdf = (type, raw = {}, patient = {}, kind = 'initial') => {
  const def = formDef(type, kind);
  const values = Object.fromEntries(Object.entries(raw || {}).map(([k, x]) => [k, Array.isArray(x) ? x : val(x)]));
  const f = formPdf(def.title, def.note || '');
  f.doc.patientInfo = Object.keys(patient || {}).length ? patient : { name: values.patientName, dob: values.dateOfBirth, mrn: values.medicalRecordNumber, dx: values.primaryDiagnosis };
  f.row([['Patient Name', values.patientName || [patient.firstName, patient.lastName].filter(Boolean).join(' '), 0.45], ['DOB', usDate(values.dateOfBirth || patient.dateOfBirth), 0.2], ['MR#', values.medicalRecordNumber || patient.medicalRecordNumber, 0.35]]);
  def.sections.forEach((sec) => {
    f.section(sec.title);
    let line = [];
    const flush = () => { if (line.length) { f.row(line.map(c => [c[0], c[1], 1 / line.length])); line = []; } };
    sec.fields.forEach((fd) => {
      if (fd.opts) {
        flush();
        f.para(fd.l, { bold: true, size: 8.5 });
        const on = picked(values[fd.k]);
        f.checks(fd.opts.map(o => [o, on.includes(o)]));
      } else if (fd.area) {
        flush();
        f.row([[fd.l, values[fd.k] || '', 1, { lines: 3 }]]);
      } else {
        line.push([fd.l, fd.date ? usDate(values[fd.k]) : values[fd.k] || '']);
        if (line.length === 3) flush();
      }
    });
    flush();
  });
  return finishPdf(f.doc, def.short);
};
